import React from 'react';
import { Sparkles, Heart, Clock, Users } from 'lucide-react';

const ServicesMenu = () => {
  const facials = [
    {
      name: 'Pure Radiance',
      duration: '30 minutes',
      price: 55,
      description: 'Focused exclusively on the face to deliver targeted results',
      icon: '✨'
    },
    {
      name: 'Harmony Escape',
      duration: '60 minutes',
      price: 105,
      description: 'Focus on face, neck, and shoulders for tension release and radiant results',
      icon: '🌸'
    },
    {
      name: 'Ultimate Indulgence',
      duration: '90 minutes',
      price: 145,
      description: 'Focuses on face, neck, shoulders, hands, and arms for overall harmony',
      icon: '💎'
    }
  ];

  const tableMassage = [
    { duration: '110 minutes', price: 199 },
    { duration: '80 minutes', price: 175 },
    { duration: '50 minutes', price: 135 },
    { duration: '35 minutes', price: 80 },
    { duration: '25 minutes', price: 65 }
  ];

  const chairMassage = [
    { duration: '20 minutes', price: 40 },
    { duration: '15 minutes', price: 35 },
    { duration: '10 minutes', price: 30 }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-rose-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-teal-600 to-teal-700 text-white py-12 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex items-center justify-center mb-4">
            <Sparkles className="w-8 h-8 mr-3" />
            <h1 className="text-4xl md:text-5xl font-serif">AYUMI SUZUKI</h1>
            <Sparkles className="w-8 h-8 ml-3" />
          </div>
          <p className="text-xl text-teal-100">Services Menu</p>
          <div className="mt-4 h-1 w-24 bg-white/50 mx-auto rounded-full"></div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-12">
        {/* Facials Section */}
        <div className="mb-16">
          <div className="text-center mb-10">
            <h2 className="text-4xl font-serif text-gray-800 mb-3">Signature Facials</h2>
            <p className="text-gray-600 italic">Experience pure luxury and rejuvenation</p>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {facials.map((facial, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 hover:scale-105 border-t-4 border-teal-500"
              >
                <div className="text-5xl mb-4 text-center">{facial.icon}</div>
                <h3 className="text-2xl font-serif text-gray-800 mb-3 text-center">{facial.name}</h3>
                <div className="flex items-center justify-center text-gray-600 mb-3">
                  <Clock className="w-4 h-4 mr-2" />
                  <span className="text-sm">{facial.duration}</span>
                </div>
                <p className="text-gray-600 text-sm text-center mb-4 min-h-[60px]">{facial.description}</p>
                <div className="text-center">
                  <span className="text-4xl font-bold text-teal-600">${facial.price}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Got Stress Section */}
        <div className="bg-gradient-to-br from-rose-50 to-teal-50 rounded-3xl p-8 md:p-12 mb-12 shadow-2xl">
          <div className="text-center mb-10">
            <Heart className="w-12 h-12 text-rose-500 mx-auto mb-4" />
            <h2 className="text-4xl md:text-5xl font-serif text-gray-800 mb-3">Got Stress?</h2>
            <p className="text-xl text-gray-700 mb-2">Book a massage. We come to you!</p>
            <div className="inline-block bg-teal-600 text-white px-6 py-2 rounded-full text-sm font-medium mt-2">
              Mobile Service Available
            </div>
          </div>

          {/* Table Massage */}
          <div className="mb-10">
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg">
              <h3 className="text-3xl font-serif text-center text-gray-800 mb-6">Table Massage</h3>
              <div className="space-y-4">
                {tableMassage.map((service, index) => (
                  <div 
                    key={index}
                    className="flex justify-between items-center py-4 px-6 bg-gradient-to-r from-teal-50 to-transparent rounded-xl hover:from-teal-100 transition-colors duration-300"
                  >
                    <span className="text-lg text-gray-700 font-medium">{service.duration}</span>
                    <span className="text-2xl font-bold text-teal-600">${service.price}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Chair Massage */}
          <div>
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg">
              <h3 className="text-3xl font-serif text-center text-gray-800 mb-6">Chair Massage</h3>
              <div className="space-y-4">
                {chairMassage.map((service, index) => (
                  <div 
                    key={index}
                    className="flex justify-between items-center py-4 px-6 bg-gradient-to-r from-rose-50 to-transparent rounded-xl hover:from-rose-100 transition-colors duration-300"
                  >
                    <span className="text-lg text-gray-700 font-medium">{service.duration}</span>
                    <span className="text-2xl font-bold text-rose-600">${service.price}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Special Notes */}
        <div className="bg-white rounded-2xl p-8 shadow-xl border-l-4 border-teal-500 mb-8">
          <div className="flex items-start">
            <Clock className="w-6 h-6 text-teal-600 mt-1 mr-3 flex-shrink-0" />
            <p className="text-gray-700 text-lg">
              A minimum of <span className="font-bold text-teal-600">two hours</span> allows everyone to fully relax and enjoy the moment
            </p>
          </div>
        </div>

        {/* Wedding Services */}
        <div className="bg-gradient-to-r from-rose-100 to-teal-100 rounded-2xl p-8 text-center shadow-xl">
          <Users className="w-12 h-12 text-rose-600 mx-auto mb-4" />
          <h3 className="text-3xl font-serif text-gray-800 mb-3">Wedding Day Bliss</h3>
          <p className="text-gray-700 text-lg mb-4">Relaxation for your special day</p>
          <a 
            href="sms:4156789133" 
            className="inline-flex items-center justify-center bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-full text-lg font-medium transition-all duration-300 hover:scale-105 shadow-lg"
          >
            <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
            </svg>
            Text us: 415-678-9133
          </a>
          <p className="text-sm text-gray-600 mt-3">Tap to send a text message</p>
        </div>

        {/* Contact Footer */}
        <div className="text-center mt-12 pt-8 border-t border-gray-200">
          <p className="text-gray-600 mb-2">Questions? We're here to help!</p>
          <a href="mailto:ayumisuzuki@yahoo.com" className="text-teal-600 hover:text-teal-700 font-medium">
            ayumisuzuki@yahoo.com
          </a>
          <p className="text-gray-500 text-sm mt-4">2528 I Street, Sacramento, CA 95816</p>
        </div>
      </div>
    </div>
  );
};

export default ServicesMenu;